export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full max-w-[340px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-3 bg-gradient-to-br from-primary-400/15 to-accent-400/15 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20entertainment%20news%20app%20interface%20with%20trending%20topics%2C%20warm%20color%20scheme%2C%20clean%20UI%20design%2C%20Chinese%20language%20interface%2C%20dark%20phone%20frame%2C%20minimalist%20aesthetic%2C%20professional%20product%20photography&width=600&height=800&seq=app-mockup-2026&orientation=portrait"
                alt="17吃瓜网APP下载界面"
                className="relative w-full h-auto rounded-2xl object-cover"
                width="600"
                height="800"
              />
            </div>
          </div>

          <div className="flex-1 space-y-5 text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full whitespace-nowrap">
              APP下载
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              随时随地 · 掌上吃瓜
            </h2>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base">
              下载<strong>17吃瓜APP</strong>，享受更流畅的<strong>吃瓜在线</strong>浏览体验。APP端支持离线缓存、推送通知、夜间模式等专属功能，让你不错过任何一条<strong>最新黑料</strong>。无论是通勤路上还是摸鱼时光，打开<strong>吃瓜APP</strong>就能即刻获取<strong>每日黑料</strong>更新。<strong>17一起吃瓜网</strong>移动端已覆盖iOS与Android双平台。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-3 bg-foreground-900 text-background-50 font-medium rounded-lg text-sm cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-fill text-lg"></i>
                iOS 下载
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-3 bg-foreground-900 text-background-50 font-medium rounded-lg text-sm cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-3 border border-foreground-200 text-foreground-700 font-medium rounded-lg text-sm cursor-pointer hover:border-primary-300 hover:text-primary-600 transition-all">
                <i className="ri-qr-code-line text-lg"></i>
                扫码下载
              </span>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs text-foreground-500 pt-1">
              <span><i className="ri-shield-check-line mr-1"></i>安全无毒</span>
              <span><i className="ri-speed-up-line mr-1"></i>极速加载</span>
              <span><i className="ri-moon-line mr-1"></i>夜间模式</span>
              <span><i className="ri-notification-3-line mr-1"></i>实时推送</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}